if (!customElements.get('collection-priority')) {
  customElements.define(
    'collection-priority',
    class CollectionPriority extends HTMLElement {
      connectedCallback() {
        if (this._started) return;
        this._started = true;
        this.load();
      }

      async load() {
        const grid = this.querySelector('[data-priority-grid]');
        if (!grid) return;

        if (this.dataset.complete === 'true') {
          this.hidden = !grid.querySelector('li');
          return;
        }

        const handle = this.dataset.collectionHandle;
        const tag = this.dataset.tagHandle;
        const sectionId = this.dataset.sectionId;
        if (!handle || !tag || !sectionId) return;

        const params = new URLSearchParams(window.location.search);
        ['page', 'phcursor', 'page_info', 'section_id'].forEach((key) => params.delete(key));
        params.set('section_id', sectionId);

        const url = `/collections/${encodeURIComponent(handle)}/${encodeURIComponent(tag)}?${params.toString()}`;

        let html = '';
        try {
          const response = await fetch(url, { credentials: 'same-origin' });
          if (!response.ok) throw new Error('priority fetch failed');
          html = await response.text();
        } catch (error) {
          this.hidden = !grid.querySelector('li');
          return;
        }

        if (!this.isConnected) return;

        const doc = new DOMParser().parseFromString(html, 'text/html');
        const source = doc.querySelector('#CollectionPrioritySource');
        const items = source ? Array.from(source.querySelectorAll(':scope > ul > li')) : [];

        if (!items.length) {
          this.hidden = !grid.querySelector('li');
          return;
        }

        const currentIds = Array.from(grid.querySelectorAll(':scope > li'), (item) => item.dataset.productId);
        const nextIds = items.map((item) => item.dataset.productId);
        const same =
          currentIds.length === nextIds.length && currentIds.every((id, index) => id === nextIds[index]);

        if (!same) grid.replaceChildren(...items);

        const productGrid = document.getElementById('product-grid');
        if (productGrid) {
          nextIds.forEach((id) => {
            if (!id) return;
            productGrid.querySelectorAll(`:scope > li[data-product-id="${id}"]`).forEach((item) => item.remove());
          });
        }

        this.hidden = !grid.querySelector('li');

        if (window.lenis) window.lenis.resize();
        if (window.ScrollTrigger) window.ScrollTrigger.refresh();
      }
    }
  );
}
